import React from 'react';
import Chart from "react-apexcharts";

const Bar = () => {
    var options = {
        chart: {
            type: 'line'
        },
        series: [{
            name: 'sales',
            data: [30, 40, 35, 50, 49, 60, 70, 91, 125]
        }],
        xaxis: {
            categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999]
        }
    }


    return (
        <div className='bg-white rounded-md drop-shadow-sm'>
            <h2 className='card-title '>Hotel Survay</h2>
            <Chart
                options={options}
                series={options.series}
                type="bar"
                width="100%"
                height='232'
            />
        </div>
    )
}


export default Bar;